<div *ngIf="item">
  <div class="cc-item clickable" (click)="openPayment(item.wId, item.paymentId)" [class.mb--4]="isChargeback">
    <div class="d-flex align-items-center overflow-hidden">
      <div class="cc-item-left">
        <div class="d-flex align-items-center justify-content-start gap--8">
          <span class="name">{{ item.name }}</span>
          <span *ngIf="isChargeback && kind !== 'settled'" class="dot"
            [class.pre-chargeback]="item.kind === 'pre-chargebacked'"
            [class.arbitration]="item.kind === 'arbitration'"
            [class.chargeback]="item.kind === 'charged-back'"
            [class.resolved]="item.kind === 'resolved'"
          ></span>
        </div>
        <ng-container *ngIf="!isChargeback; else chargebackTemplate">
          <div class="d-flex align-items-center gap--12">
            <small class="sub-info">
              {{ item.kind === 'refund' ? 'Refund transaction' : 'Transaction' }} ID {{ getTransactionIdMask(item.transactionId) }}
            </small>
            <app-icon src="copy" class="se-icon-button copy-button" (click)="copyTransactionId($event)"></app-icon>
          </div>
        </ng-container>
        <ng-template #chargebackTemplate>
          <div class="d-flex align-items-center gap--12">
            <small class="sub-info transaction-id show">
              Chargeback Transaction ID {{ getTransactionIdMask(item.transactionId) }}
            </small>
            <app-icon src="copy" class="se-icon-button copy-button" (click)="copyTransactionId($event)"></app-icon>
          </div>
        </ng-template>
      </div>
    </div>

    <div class="cc-item-right">
      <div class="amount"
        [class.red]="(kind === 'settled' && (item.amount < 0 || item.kind === 'charged-back' || item.kind === 'refund')) || kind === 'refund'"
        [shortNumber]="(item.paidAmount ?? item.amount) | currency"
        #tooltip="matTooltip"
        [matTooltip]="''"
        [shortNumberTooltip]="tooltip"
        [hideTooltipOnScroll]="tooltip"
      ></div>
    </div>
  </div>

  <ng-container *ngIf="isChargeback">
    <div class="detailed-info-block" [class.expanded]="expanded">
      <div>
        <h4 class="reason-caption">Reason</h4>
        <div class="cc-item-divider"></div>
      </div>
      <p class="reason-text">{{ item.reason }}</p>
      <small class="sub-info mt--8" *ngIf="item.kind !== 'resolved'">Chargeback {{ item.chargeback | currency }}</small>
      <small class="sub-info" *ngIf="kind === 'pre-chargeback'">Due date {{ item.dueDate | date:'MM/dd/YY' }}</small>
      <small class="sub-info">Fee {{ item.fee | currency }}</small>
    </div>

    <div class="d-flex justify-content-center align-items-center mb--20 cb-arrow">
      <app-icon
        class="se-icon-button no-bg no-hover"
        [class.transform]="expanded" src="cheveron_down"
        width="24" height="24"
        (click)="toggleExpand()"
      ></app-icon>
    </div>
  </ng-container>
</div>

<div *ngIf="dividerNeed" class="cc-item-divider"></div>
